import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import { actions as rankingActions } from 'features/ranking';

export default function usePragmaticTournament() {
  const [monthState, setMonthState] = useState({
    value: dayjs().format('YYYY-MM'),
    month: 'current',
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const { actionProcessing, myRank, agentsRanking, withRanking, rubyPlayRanking, pragmaticSlotsRanking, pragmaticLiveRanking } = useSelector(s => s.rankings);

  useEffect(() => {
    dispatch(rankingActions.getPragmaticAgentsRanking({ date: monthState.value, type: 'pragmatic-slots' }));
    dispatch(rankingActions.getPragmaticAgentsRanking({ date: monthState.value, type: 'pragmatic-live-casino' }));
  }, [withRanking, monthState.month]);

  const toggleMonth = useCallback(() => {
    const currentMonth = dayjs().format('YYYY-MM');
    const previousMonth = dayjs().subtract(1, 'month').format('YYYY-MM');

    setMonthState(() => {
      if (monthState.month === 'current') {
        return {
          value: previousMonth,
          month: 'previous',
        };
      } else {
        return {
          value: currentMonth,
          month: 'current',
        };
      }
    });
  }, [monthState.month]);

  return {
    actionProcessing,
    agentsRanking,
    rubyPlayRanking,
    myRank,
    toggleMonth,
    month: monthState.month,
    pragmaticSlotsRanking,
    pragmaticLiveRanking,
    withPragmaticTables: true,
  };
}
